"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inputFormInstructio;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = (_inputFormInstructio = {
  'inputForm.instruction': 'Alla fält är obligatoriska om de inte är markerade som valfria',
  'inputField.label.firstName': 'Förnamn',
  'inputField.label.lastName': 'Efternamn',
  'inputField.label.fullName': 'Namn på kortet',
  'inputField.label.Email': 'E-post',
  'inputField.label.phoneNumber': 'Telefonnummer',
  'inputField.placeholder.firstName': 'John',
  'inputField.placeholder.lastName': 'Doe',
  'inputField.placeholder.fullName': 'John Doe',
  'inputField.placeholder.email': 'john.doe@cashstar.com',
  'inputField.placeholder.phoneNumber': 'Ange telefonnummer',
  'inputField.errorMessage.incompleteField': 'Ofullständigt fält',
  'inputField.errorMessage.exceedsMaxCharacters': 'Överskrider {max} tecken',
  'inputField.errorMessage.exceedsNameOnCardMaxCharacters': "Namnet på kortet är för långt. Ange {max} tecken eller färre.",
  'inputField.errorMessage.pleaseEnterAValidFirstName': 'Vänligen ange ett giltigt förnamn',
  'inputField.errorMessage.pleaseEnterAValidLastName': 'Vänligen ange ett giltigt efternamn',
  'inputField.errorMessage.pleaseEnterAValidFullName': 'Vänligen ange ett giltigt fullständigt namn',
  'inputField.errorMessage.invalidAddressValue': 'Vänligen ange en giltig adress',
  'inputField.errorMessage.invalidCityValue': 'Ange en giltig stad',
  'inputField.errorMessage.invalidName': 'Ange ett giltigt namn',
  'header.text.billingInfo': 'Faktureringsinformation',
  'submitButton.adyen.label': 'Betala nu',
  'inputField.label.cardNumber': 'Kortnummer',
  'inputField.label.cardExpiry': 'Utg.datum (MM/ÅÅ)',
  'inputField.label.cardCVV': 'CVV/CVC',
  'inputField.placeholder.cardNumber': 'Kortnummer',
  'inputField.placeholder.cardExpiry': 'MM/ÅÅ',
  'inputField.placeholder.cardCVV': '3 eller 4 siffror',
  'inputField.errorMessage.cardNumberEmpty': 'Ange ditt kortnummer',
  'inputField.errorMessage.expiryDateEmpty': 'Ange ditt korts utgångsdatum',
  'inputField.errorMessage.cardCVVEmpty': 'Ange kortet CVV/CVC',
  'inputField.errorMessage.zipCodeEmpty': "Ange din faktureringsadress postnummer",
  'inputField.errorMessage.addressLineOneEmpty': 'Ange första raden i din adress',
  'inputField.errorMessage.cityEmpty': 'Ange din stad',
  'inputField.errorMessage.stateEmpty': 'Välj ditt tillstånd',
  'inputField.errorMessage.emptyNameOnCard': 'Ange namnet på betalkortet',
  'inputField.errorMessage.invalidCardNumber': 'Ogiltigt kortnummer. Kontrollera att du har angett det korrekt, eller prova ett annat betalkort.',
  'inputField.errorMessage.cardTypeNotSupported': "Tyv\xE4rr, vi accepterar inte den h\xE4r korttypen. F\xF6rs\xF6k med ett annat betalkort.",
  'inputField.errorMessage.emptyFirstName': 'Ange ditt förnamn',
  'inputField.errorMessage.emptyLastName': 'Ange ditt efternamn',
  'inputField.errorMessage.emptyEmail': 'Ange din e-postadress',
  'inputField.errorMessage.emptyPhone': 'Ange ditt telefonnummer',
  'inputField.errorMessage.pleaseEnterAValidEmailAddress': "Ange din e-postadress i rätt format, som namn@example.com",
  'inputField.errorMessage.pleaseEnterAValidPhoneNumber': 'Ange ett giltigt telefonnummer',
  'inputField.errorMessage.invalidCardExpiry': "Vänligen ange ett giltigt utgångsdatum",
  'inputField.errorMessage.cardExpired': "Kortets utgångsdatum måste ligga i framtiden",
  'inputField.errorMessage.invalidCardCVV': 'Ange en giltig CVV/CVC',
  'inputField.label.saveCardLabel': 'Spara till senare',
  'inputField.label.makeAsDefaultLabel': 'Markera som standard',
  'paymentMethod.paypal.login.initial': "För att slutföra kassan via PayPal, vänligen logga in och validera betalningsinformationen",
  'paymentMethod.paypal.login.success': 'Du betalar med PayPal. Fortsätt att skicka din beställning',
  'paymentMethod.zipPay.minCartAmount': 'Minsta beställningsvärde för att använda Zip är $35',
  'inputField.label.country': 'Land',
  'paymentMethod.zipPay.additionalCharges': "En extra säljaravgift upp till {amount} kan tillkomma din beställningssumma för att använda Zip.",
  'paymentMethod.adyen.label': 'Kredit-/betalkort och e-bank',
  'paymentMethod.adyen.single.label': 'Kredit-/betalkort',
  'paymentMethod.paypal.label': 'PayPal',
  'paymentMethod.zippay.label': 'Zip',
  'paymentMethod.creditCard.label': 'Kredit-/betalkort',
  'paymentMethod.googlePay.label': 'Google Pay',
  'paymentMethd.applePay.label': 'Apple Pay',
  'modal.title': 'Är du säker på att du vill ta bort?',
  'modal.button.disagree': 'Nej',
  'modal.button.agree': 'Ja',
  'paymentMethod.zippay.preview.message': 'Minsta beställningsvärde för att använda Zip är $35',
  'inputField.label.addressLine.de': 'Gatuadress',
  'inputField.label.addressLineTwo.de': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.de': 'State',
  'inputField.label.city.de': 'Stad',
  'inputField.label.zipcode.de': 'Postnummer',
  'inputField.label.addressLine.ca': 'Gatuadress',
  'inputField.label.addressLineTwo.ca': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.ca': 'Provins',
  'inputField.label.city.ca': 'Stad',
  'inputField.label.zipcode.ca': 'Postnummer',
  'inputField.label.addressLine.gb': 'Gatuadress',
  'inputField.label.addressLineTwo.gb': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.gb': 'County',
  'inputField.label.city.gb': 'Stad',
  'inputField.label.zipcode.gb': 'Postnummer',
  'inputField.label.addressLine.us': 'Gatuadress',
  'inputField.label.addressLineTwo.us': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.us': 'State',
  'inputField.label.city.us': 'Stad',
  'inputField.label.zipcode.us': 'Postnummer',
  'inputField.label.addressLine.jp': 'Gatuadress',
  'inputField.label.addressLineTwo.jp': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.jp': 'Prefektur',
  'inputField.label.city.jp': 'Stad',
  'inputField.label.zipcode.jp': 'Postnummer',
  'inputField.label.addressLine.nl': 'Gatuadress',
  'inputField.label.addressLineTwo.nl': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.nl': 'Provins',
  'inputField.label.city.nl': 'Stad',
  'inputField.label.zipcode.nl': 'Postnummer',
  'inputField.label.addressLine.mx': 'Gatuadress',
  'inputField.label.addressLineTwo.mx': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.mx': 'State',
  'inputField.label.city.mx': 'Stad',
  'inputField.label.zipcode.mx': 'Postnummer',
  'inputField.label.addressLine.se': 'Gatuadress',
  'inputField.label.addressLineTwo.se': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.se': 'Grevskap',
  'inputField.label.city.se': 'Stad',
  'inputField.label.zipcode.se': 'Postnummer',
  'inputField.label.addressLine.it': 'Gatuadress',
  'inputField.label.addressLineTwo.it': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.it': 'Grevskap',
  'inputField.label.city.it': 'Stad',
  'inputField.label.zipcode.it': 'Postnummer',
  'inputField.label.addressLine.ie': 'Gatuadress',
  'inputField.label.addressLineTwo.ie': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.ie': 'Grevskap',
  'inputField.label.city.ie': 'Stad',
  'inputField.label.zipcode.ie': 'Postnummer',
  'inputField.label.addressLine.au': 'Gatuadress',
  'inputField.label.addressLineTwo.au': 'Gatuadress 2 (valfritt)',
  'inputField.label.state.au': 'Grevskap',
  'inputField.label.city.au': 'Stad',
  'inputField.label.zipcode.au': 'Postnummer',
  'inputField.errorMessage.stateEmpty.us': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.ca': 'Välj din provins',
  'inputField.errorMessage.stateEmpty.gb': 'Välj ditt län',
  'inputField.errorMessage.stateEmpty.nl': 'Välj din provins',
  'inputField.errorMessage.stateEmpty.jp': 'Välj din prefektur',
  'inputField.errorMessage.stateEmpty.de': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.mx': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.se': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.au': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.ie': 'Välj ditt tillstånd',
  'inputField.errorMessage.stateEmpty.it': 'Välj ditt tillstånd',
  'inputField.errorMessage.zipCodeEmpty.jp': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.us': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.gb': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.ca': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.de': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.nl': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.mx': 'Ange din faktureringsadress Postnummer',
  'inputField.errorMessage.zipCodeEmpty.se': 'Ange din faktureringsadress Postnummerr',
  'inputField.errorMessage.zipCodeEmpty.au': 'Ange din faktureringsadress Postcode',
  'inputField.errorMessage.zipCodeEmpty.ie': 'Ange din faktureringsadress Postnummerr',
  'inputField.errorMessage.zipCodeEmpty.it': 'Ange din faktureringsadress Postnummerr',
  'inputField.errorMessage.invalidZipcode.jp': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.us': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.gb': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.ca': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.de': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.nl': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.mx': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.se': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.au': 'Ange ett giltigt postcode',
  'inputField.errorMessage.invalidZipcode.ie': 'Ange ett giltigt postnummer',
  'inputField.errorMessage.invalidZipcode.it': 'Ange ett giltigt postnummer',
  'inputField.label.addressLine': 'Gatuadress',
  'inputField.label.addressLineTwo': 'Gatuadress 2 (valfritt)',
  'inputField.label.state': 'State',
  'inputField.label.city': 'Stad',
  'inputField.label.zipcode': 'Postnummer',
  'inputField.placeholder.addressLine': 'Adress',
  'inputField.placeholder.addressLineTwo': 'Adressrad 2 (valfritt)',
  'inputField.placeholder.zipCode': 'Postnummer',
  'inputField.placeholder.city': 'Stad',
  'inputField.placeholder.state': '- Välj tillstånd -'
}, _defineProperty(_inputFormInstructio, "inputField.errorMessage.zipCodeEmpty", "Ange din faktureringsadress postnummer"), _defineProperty(_inputFormInstructio, "inputField.errorMessage.addressLineOneEmpty", 'Ange första raden i din adress'), _defineProperty(_inputFormInstructio, 'inputField.errorMessage.addressLineTwoEmpty', 'Ange den andra raden i din adress'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.cityEmpty", 'Ange din stad'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.stateEmpty", 'Välj ditt tillstånd'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.incompleteField", 'Ofullständigt fält'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.invalidAddressValue", 'Vänligen ange en giltig adress'), _defineProperty(_inputFormInstructio, "inputField.errorMessage.invalidCityValue", 'Ange en giltig stad'), _defineProperty(_inputFormInstructio, 'inputField.errorMessage.invalidZipcode', 'Ange ett giltigt postnummer'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.us', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.de', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.mx', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.af', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.br', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.at', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.es', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.fr', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.nl', '- Välj provins -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.ca', '- Välj provins -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.gb', '- Välj län -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.jp', '- Välj prefektur -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.se', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.au', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.ie', '- Välj tillstånd -'), _defineProperty(_inputFormInstructio, 'inputField.placeholder.state.it', '- Välj tillstånd -'), _inputFormInstructio);
exports.default = _default;